<template>
    <div class="t-helper mgt-16 mgr-16 mgl-16">
        <transition name="fade">
            <div class="question-tag correct" @click="toggleExpendCorrectRate()">
                {{correctRateExpend ? $t('1251') + ' | ' : ''}} {{$t('1249', {str: correctRate})}}
            </div>
        </transition>

        <transition name="fade">
            <div class="question-tag time mgr-4 mgl-4" @click="toggleExpendAvgSolveTimeExpend()">
                {{avgSolveTimeExpend ? $t('1252') + ' | ' : ''}} {{$t('1250', {str: avgSolveTime})}}
            </div>
        </transition>
        
        <transition name="fade">
            <div class="question-tag level" @click="toggleExpendLevelExpend()" v-if="level">
                {{levelExpend ? $t('1253') + ' | ' : ''}} {{level}}
            </div>
        </transition>        
    </div>
</template>

<script>
// Components/Mixin/Extend/API 선언
/**
 * 문항별 태그 공통 컴포넌트(question tag common component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
   props: ['correctRate', 'avgSolveTime', 'level'],
   data() {
       return {
           correctRateExpend: false,
           avgSolveTimeExpend: false,
           levelExpend: false
       }
   },
   methods: {
       toggleExpendCorrectRate() {
           this.correctRateExpend = !this.correctRateExpend
           this.avgSolveTimeExpend = false;
           this.levelExpend = false;
       },
       toggleExpendAvgSolveTimeExpend() {
           this.avgSolveTimeExpend = !this.avgSolveTimeExpend
           this.levelExpend = false;
           this.correctRateExpend = false;
       },
       toggleExpendLevelExpend() {
           this.levelExpend = !this.levelExpend
           this.correctRateExpend= false;
           this.avgSolveTimeExpend = false;
       }
   }
}
</script>